import { api } from './index'

// Per-merchant reply-to addresses (OPE-519). Two free-form, email-format-validated
// values; a blank value means "no-reply" (the product default, applied backend-side).
// Wire contract is the merchant-api `reply_to_configuration` resource (OPE-518):
// merchant scope is implicit in the base URL (`/merchants/:current_merchant_id`),
// and the resource is wrapped under the `reply_to_configuration` root key.
export type EmailReplyRouting = {
  reply_to_marketing: string | null
  reply_to_transactional: string | null
}

export type EmailReplyRoutingResponse = {
  reply_to_configuration: EmailReplyRouting
}

export type UpdateEmailReplyRoutingPayload = {
  reply_to_configuration: {
    reply_to_marketing: string
    reply_to_transactional: string
  }
}

export const emailReplyRoutingApi = api.injectEndpoints({
  endpoints: builder => ({
    getEmailReplyRouting: builder.query<EmailReplyRoutingResponse, void>({
      query: () => ({ url: 'reply_to_configuration' }),
      providesTags: ['EmailReplyRouting'],
    }),

    updateEmailReplyRouting: builder.mutation<
      EmailReplyRoutingResponse,
      UpdateEmailReplyRoutingPayload
    >({
      query: payload => ({
        url: 'reply_to_configuration',
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['EmailReplyRouting'],
    }),
  }),
})

export const {
  useGetEmailReplyRoutingQuery,
  useUpdateEmailReplyRoutingMutation,
} = emailReplyRoutingApi
